export default __webpack_public_path__ + "static/reactHooks-7566338df037b2890e694414b5ff8e64.svg";